import axiosPost from "./axiosPost";

export const RNHDepartamentoUpd = async (credentials, data) => {
    const body = {
        service: "RNHDepartamentoUpd",
        params: {
            rnhDepartamentoId: data?.id,
            rnhDepartamentoCod: data?.cod,
            rnhDepartamentoNombre: data?.name,
            rnhDepartamentoDescripcion: data?.desc,
            rnhDepartamentoVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
